export const Lightning = ({
  size = "16",
  color = "#CFA50A",
}: {
  size?: string;
  color?: string;
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4266 7.40153L13.4267 7.40188C13.4433 7.47213 13.442 7.54543 13.4229 7.61505C13.4039 7.68468 13.3676 7.7484 13.3175 7.80037L13.3168 7.8011L6.31689 15.301C6.27635 15.3443 6.2273 15.3788 6.17282 15.4023C6.11842 15.4257 6.05978 15.4377 6.00055 15.4375C5.93007 15.4368 5.86068 15.42 5.79769 15.3883C5.71459 15.3433 5.64804 15.2729 5.60774 15.1874C5.56732 15.1016 5.55543 15.0052 5.57382 14.9121C5.57382 14.9121 5.57383 14.9121 5.57383 14.9121L6.48631 10.331L6.49668 10.2789L6.44696 10.2602L2.84762 8.91048C2.84753 8.91045 2.84744 8.91041 2.84735 8.91038C2.77992 8.88417 2.71981 8.84208 2.6721 8.7877C2.62438 8.7333 2.59049 8.66819 2.57329 8.59791C2.55673 8.52772 2.55804 8.4545 2.57709 8.38494C2.59617 8.31532 2.63242 8.2516 2.68251 8.19962L2.68252 8.19963L2.68321 8.19889L9.68321 0.698895L9.68332 0.69877C9.74803 0.629061 9.83397 0.5827 9.92776 0.566903C10.0215 0.551117 10.1178 0.566739 10.2017 0.611338C10.2851 0.656365 10.3519 0.7269 10.3923 0.812619C10.4327 0.898374 10.4446 0.994817 10.4262 1.08782C10.4262 1.08784 10.4262 1.08786 10.4262 1.08787L9.51372 5.66904L9.50334 5.72112L9.55307 5.73977L13.1531 7.08977L13.1532 7.08981C13.221 7.1151 13.2814 7.15681 13.3292 7.21122C13.3769 7.26562 13.4104 7.33101 13.4266 7.40153Z"
        fill={color}
        stroke="white"
        strokeWidth="0.125"
      />
    </svg>
  );
};
